/**
 * YouTube link helpers for the notice presentation video. Accepts the formats
 * YouTube hands out (`watch?v=`, `youtu.be/`, `embed/`, `shorts/`, `live/`),
 * with or without `www.`/`m.` and with extra query params. The video ID is 11
 * chars of `[A-Za-z0-9_-]`. The backend applies the same rule and stores the
 * canonical `watch?v=<ID>` form.
 */
const YOUTUBE_HOSTS = '(?:https?:\\/\\/)?(?:www\\.|m\\.)?';
const YOUTUBE_PATHS =
  '(?:youtube\\.com\\/(?:watch\\?(?:[^#]*&)?v=|embed\\/|shorts\\/|live\\/)|youtu\\.be\\/)';
const YOUTUBE_ID = '([A-Za-z0-9_-]{11})(?![A-Za-z0-9_-])';

const YOUTUBE_PATTERN = new RegExp(
  `^${YOUTUBE_HOSTS}${YOUTUBE_PATHS}${YOUTUBE_ID}`,
  'i'
);

export const extractYoutubeId = (url: string): string | null => {
  const match = url.trim().match(YOUTUBE_PATTERN);
  return match ? match[1] : null;
};

export const youtubeWatchUrl = (videoId: string): string =>
  `https://www.youtube.com/watch?v=${videoId}`;

export const youtubeEmbedUrl = (videoId: string): string =>
  `https://www.youtube.com/embed/${videoId}`;
